import { useEffect, useState } from 'react'
import { WaveformManager } from 'services/waveform-manager'

interface IUseWaveformResult {
  peaks: Float32Array | null
  isLoading: boolean
}

const INITIAL_STATE: IUseWaveformResult = {
  peaks: null,
  isLoading: true
}

export const useWaveform = (
  serverSidePeaks: Float32Array<ArrayBufferLike> | null,
  assetId: string,
  url: string,
  fileSize?: number,
  duration?: number
): IUseWaveformResult => {
  const [state, setState] = useState<IUseWaveformResult>(INITIAL_STATE)

  useEffect(() => {
    if (serverSidePeaks || !assetId || !url) {
      setState({ peaks: null, isLoading: false })
      return
    }

    let cancelled = false
    const worker = WaveformManager.getInstance()
    setState(INITIAL_STATE)
    worker.request({ assetId, url, fileSize, duration }).then(result => {
      if (cancelled) return
      setState({
        peaks: result?.peaks ?? null,
        isLoading: false
      })
    })

    return () => {
      cancelled = true
      worker.release(assetId)
    }
  }, [assetId, url, fileSize, duration, serverSidePeaks])

  return state
}
